<script>
  export const IMAGE_DIMENSIONS = {
    simple: {
      width: 135,
      height: 135
    },
    teaser: {
      width: 300,
      height: 170
    },
    teaserBig: {
      width: 630,
      height: 360
    },
    indicator: {
      width: 95,
      height: 56
    },
    award: {
      width: 135,
      height: 70
    },
    icon: {
      width: 24,
      height: 24
    }
  }

  export default {
    props: {
      url: String,
      isCoreMedia: Boolean,
      alt: String,
      lazy: Boolean,
      width: {
        type: Number,
        required: true
      },
      height: {
        type: Number,
        required: true
      }
    },
    computed: {
      src () {
        if (this.isCoreMedia) {
          const pdRegex = new RegExp('pd=[0-9]*')
          const pdParam = this.url.match(pdRegex)
          const sizePosition = pdParam && pdParam[0] ? this.url.search(pdRegex) + pdParam[0].length : this.url.lastIndexOf('.')

          return `${this.url.slice(0, sizePosition)},h=${this.height},w=${this.width}${this.url.slice(sizePosition)}`
        }

        return this.url
      }
    }
  }
</script>

<template>
  <img :src="src" :loading="lazy ? 'lazy' : false" :alt="alt || false" :width="width" :height="height" />
</template>
